import { Checkbox } from "@ps-design-system/components/Checkbox";
import { Text } from "@ps-design-system/components/Text";
import PropTypes from "prop-types";
import * as React from "react";
import { FormattedMessage } from "react-intl";

export const TosCheckbox = ({ urlPrefix, isChecked, setIsChecked }) => {
  return (
    <Checkbox
      id="tos-checkbox"
      testId="tos-checkbox"
      variant="box"
      alignment="top"
      onCheckedChange={setIsChecked}
      checked={isChecked}
      description={
        <Text
          style={{
            color: "#6A6E7A",
            textTransform: "none", // overrides global lowercase style on "label" elements
          }}
          typeface="body-1-long"
        >
          <FormattedMessage
            id="booking_request_page.tos_checkbox.agreement"
            defaultMessage="I understand and accept {servicesAgreement}, which includes the {cancellationPolicy}."
            values={{
              servicesAgreement: (
                <Text
                  element="a"
                  typeface="body-1-long"
                  style={{ textDecoration: "underline", color: "#121212" }}
                  href={`https://www.peerspace.com${urlPrefix}/legal/terms`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <FormattedMessage
                    id="booking_request_page.services_agreement"
                    defaultMessage="Peerspace's Services Agreement"
                  />
                </Text>
              ),
              cancellationPolicy: (
                <Text
                  element="a"
                  typeface="body-1-long"
                  style={{ textDecoration: "underline", color: "#121212" }}
                  href={`https://www.peerspace.com${urlPrefix}/legal/terms/cancellation-policy`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <FormattedMessage
                    id="booking_request_page.cancellation_refund_policy"
                    defaultMessage="Cancellation and Refund Policy"
                  />
                </Text>
              ),
            }}
          />
        </Text>
      }
    />
  );
};

TosCheckbox.propTypes = {
  urlPrefix: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  setIsChecked: PropTypes.func.isRequired,
};
